import { useNavigate, useRouter } from '@tanstack/react-router';

import { NavigationBar } from '@/components/NavigationBar';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useEffectiveCategoryLabels } from '@/hooks/use-effective-category-labels';
import { PRODUCT_STEPS } from '@/lib/products';

import { ProductSelectionSubmitFeedback } from './components/ProductSelectionSubmitFeedback';

export const NoProductsSelected = () => {
  const navigate = useNavigate();
  const router = useRouter();

  const effectiveCategoryLabels = useEffectiveCategoryLabels();
  const firstProductStep = PRODUCT_STEPS.find((step) => effectiveCategoryLabels.includes(step.id));

  const handleRequestSupplies = () => {
    if (firstProductStep) {
      navigate({ to: firstProductStep.url });
    } else {
      router.history.back();
    }
  };

  return (
    <section>
      {firstProductStep && (
        <NavigationBar
          backLabel={firstProductStep.name}
          onBack={() => navigate({ to: firstProductStep.url })}
        />
      )}
      <Card>
        <CardHeader>
          <CardTitle className="text-center">You haven’t chosen any supplies</CardTitle>
        </CardHeader>

        <CardContent className="flex flex-col items-center justify-center gap-7">
          <div className="text-md text-center">
            Please select the items you'd like Conduit Health to help get covered.
          </div>

          <Button type="button" onClick={handleRequestSupplies}>
            Request covered supplies
          </Button>
          <ProductSelectionSubmitFeedback />
        </CardContent>
      </Card>
    </section>
  );
};
